<!-- white-block template -->
<template>
  <div class="'content spVisible">
    <table class="content_table">
      <tr>
        <th class="content_r_info">
          <i class="fas fa-crown crownsizeOver3 color_gold"></i>
          <span class="top5rankOver3 color_gold">{{ item.rank }}</span>
        </th>
        <td class="content_table_img_td">
          <a :href="'category/' + item.categoryId + '.html#' + item.magazineId">
            <img
              :src="item.coverImage"
              target="_blank"
              alt=""
              class="imgOver3"
            />
          </a>
        </td>
        <td>
          <div class="magazineTitle titleOver3">
            <a :href="'category/' + item.categoryId + '.html#' + item.magazineId">
              {{ item.magazineTitle }}
            </a>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.content {
  margin: 0 auto;
  display: flex;
  box-sizing: border-box;
  max-width: 800px;
  height: 100%;
}
.content_l {
  height: 100%;
}

.magazineDescription {
  font-size: 14px;
  height: auto;
  margin: 0 15px 0;
  padding: 17px 0 0;
  height: 455px;
  letter-spacing: 0.8px;
  word-break: normal;
  display: inline-block;
}
.magazineDescription img {
  width: 100%;
  max-width: 125px;
  max-height: 125px;
  object-fit: cover;
  float: left;
  margin: 0 0 10px 10px;
}
.content_r {
  max-width: 65px;
  display: block;
  text-align: center;
  margin: 0 5px 0 10px;
  height: 100%;
}
.crownsize {
  font-size: 42px;
}
.magazineTitle,
.top5rank {
  font-size: 20px;
  width: 100%;
}
.magazineTitle {
  width: 55px;
  margin: -5px auto 0;
  height: 334px;
  text-align: left;
  font-size: 18px;
  display: flex;
  writing-mode: vertical-rl;
  align-items: center;
  line-height: 1.4;
  letter-spacing: 1.5px;
}
.top5rank {
  font-size: 68px;
  display: block;
  margin-top: -15px;
}

.top5rankOver3 {
  font-size: 34px;
  display: block;

  font-family: 'futura-pt', futura, 'Century Gothic', 游ゴシック体, YuGothic,
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic',
    メイリオ, Meiryo, sans-serif;
  font-weight: 500;
  margin-left: 5px;
}
.crownsizeOver3 {
  font-size: 22px;
}
.imgOver3 {
  width: 70px;
  height: 70px;
  object-fit: cover;
}
.titleOver3 {
  font-size: 18px;
  margin: 10px auto 0;
  height: 313px;
}
.vertical {
  writing-mode: vertical-rl;
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: vertical-rl;
}
.color_gold {
  color: #d2ac31;
}

.white-block__container {
  max-width: 1200px;
  /* width: 95%; */
  background: #fff;
}

.spVisible {
  display: none;
}

@media screen and (max-width: 768px) {
  .sphidden {
    display: none;
  }
  .spVisible {
    display: block;
  }
  .topWideColWarp {
  }
  .content_table {
    display: flex;
    width: 100%;
    max-width: 100%;
    margin: 0 auto !important;
  }
  .content_table tr {
    display: flex;
    margin: 1em 0;
    align-items: center;
    justify-content: center;
  }
  .content_table th {
    text-align: center;
  }
  .content_table td {
    margin: 0 0.5em;
  }
  .content_table_img_td {
    width: 90px;
  }
  .content_r_a {
    display: flex;
    justify-content: flex-start;
  }
  .magazineTitle {
    writing-mode: inherit;
    width: 100% !important;
    height: auto;
    font-size: 16px !important;
  }
  .table_ {
    margin: 0 auto;
    display: block;
    padding: 0 20px;
  }
  .content_r i {
    align-self: center;
    font-size: 36px;
  }
  .content_r .top5rankOver3 {
    align-self: center;
    font-size: 48px !important;
    margin: -13px 0 0;
  }
  .content_r img {
    align-self: center;
    width: 61px;
    height: 61px;
    margin-right: 16px;
  }
  .content_r_info {
    margin-right: 12px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 30px;
  }
  .topWideColWarp .topWideColContentBox .topWideColContent {
    margin: 0 0 30px !important;
  }
  .content_r_info i {
    font-size: 26px;
  }
  .content_r_info .top5rankOver3 {
    font-size: 36px;
  }
}
@media screen and (max-width: 480px) {
  .content_r_info {
    display: block;
  }
}

@media screen and (max-width: 320px) {
  .topWideColWarp .topWideColContentBox {
    padding: 0 10px;
  }
}
</style>
